module.exports = __webpack_public_path__ + "img/position.d9307650.svg";